export default __webpack_public_path__ + "static/media/LENS_ERVOIDES_SIRE_fragment_3.c2aeee7b.jpg";